export default "__VITE_ASSET__a8030e09__"